<template>
  <div class="reaction-preview-wrapper">
    <i name="icon-preview" class="icon-preview" :class="[weight, icon]" :style="{color: color}"></i>
  </div>
</template>

<script>
  export default {
    props: {
      icon: {
        type: String,
        default: '',
      },
      weight: {
        type: String,
        default: '',
      },
      color: {
        type: String,
        default: '#000',
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>